import type { FC } from 'react'
import RecipientRadioOpt from '../RecipientRadioOpt'
import { classNames } from '@g4g/utils/src/react/class-names'
import Spinner from '@g4g/ui/src/internal/Spinner'
import AttentionBox from '@g4g/ui/src/components/AttentionBox'
import useRecentRecipients from '../hooks/useRecentRecipients'

const RecipientRecent: FC = () => {
  const { recent, loading, error } = useRecentRecipients()

  if (loading) {
    return (
      <div className="flex justify-center w-full">
        <Spinner className="w-6 h-6 text-white" delay={500} />
      </div>
    )
  }

  if (error) {
    return <AttentionBox filled>Failed to retrieve recent recipients</AttentionBox>
  }

  return (
    <>
      {recent && recent.length > 0 && (
        <div data-cy="shop-recipient-history">
          <div className="mb-2 text-sm text-white/50">Recent</div>
          <div className={classNames('flex flex-col w-full space-y-4')}>
            {recent.map((recipient) => (
              <RecipientRadioOpt key={recipient.cosId} recipient={recipient} />
            ))}
          </div>
        </div>
      )}
    </>
  )
}

export default RecipientRecent
